<div *ngIf="certificates.length === 0">The default certificate is being used</div>
<div *ngFor="let certificate of certificates">
  <ac-line-separator [title]="certificate.alias"></ac-line-separator>
  <span class="raw" [innerHTML]="certificate.raw"></span>
<!--  <div class="parsed-certificate">
    <mat-form-field class="fullWidth">
      <mat-label>Certificate</mat-label>
      <textarea matInput cdkTextareaAutosize [(ngModel)]="certificate.parsedCertificate" name="parsedCertificate" cdkAutosizeMinRows="6" [disabled]="true"></textarea>
    </mat-form-field>
  </div>-->

  <div class="pem-certificate">
    <div class="pem-actions">
      <span><i class="fa fa-download download" matTooltip="Download" (click)="downloadPem(certificate)"></i></span>
      <span><i class="fa fa-copy copy" matTooltip="Copy to clipboard" [cdkCopyToClipboard]="certificate.pem"></i></span>
    </div>
    <mat-form-field class="fullWidth">
      <mat-label (click)="downloadPem(certificate)">PEM</mat-label>
      <textarea matInput cdkTextareaAutosize [(ngModel)]="certificate.pem" name="certificate" cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" [disabled]="true"></textarea>
    </mat-form-field>
  </div>
</div>
